import React from 'react';
import PropTypes from 'prop-types';
import { FaEllipsisH } from 'react-icons/fa';
import IconButton from './IconButton';
import { MEDIUM_ICON_SIZE } from '../../../../../constants/theme';

const MenuButton = ({
  items = [], iconSize = MEDIUM_ICON_SIZE, isNewSite = false, isShow, onToggle,
}) => {
  const actionItems = isNewSite ? [items[1]] : items;
  const itemClass = isNewSite ? 'p-0 hover:text-vamos-green1' : 'p-2 hover:text-vamos-green1';
  const itemLists = items && items.length && (
    <ul className="three-dot-list bg-vamos-true-white shadow-md rounded-lg">
      {actionItems.map((item) => (
        <li
          className={`${itemClass} cursor-pointer text-left text-sm px-3`}
          key={item.label}
          onClick={(e) => {
            onToggle(false);
            item.onClick(e);
          }}
          aria-hidden="true"
        >
          {item.label}
        </li>
      ))}
    </ul>
  );

  return (
    <div className="relative">
      <IconButton
        className={`${isShow ? 'bg-vamos-green1' : 'bg-vamos-true-white'} rounded-full w-8 h-8 flex items-center justify-center focus:outline-none`}
        icon={<FaEllipsisH className={`${isShow ? 'text-vamos-white' : 'text-vamos-black'}`} size={iconSize} />}
        onClick={() => onToggle(!isShow)}
      />
      {isShow && (
        <div className="absolute mt-2 right-0 bg-vamos-true-white shadow-lg z-50 rounded-lg">
          {itemLists}
        </div>
      )}
    </div>
  );
};

MenuButton.propTypes = {
  items: PropTypes.array,
  iconSize: PropTypes.string,
  isNewSite: PropTypes.bool,
  isShow: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default MenuButton;
